/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { BlendBridge } from 'blb-types/blendBridge';
import { Route } from 'blb-components/AuthenticatedApp/routeConfiguration';
import {
  getDefaultDocumentSectionConfigs,
  getSupportContactInfoForPrincipal,
  renderDefaultDashboardOverview,
  renderDefaultProfileSidebar,
  SupportContact,
} from '../common';
import { DashboardSectionItem } from 'blb-components/AuthenticatedApp/DashboardPage/DashboardSectionItem';
export { getProfileTabs, getPipelinePollingInterval, getDashboardBanner } from '../common';

export const getSupportContactInfo = (): SupportContact => getSupportContactInfoForPrincipal('insurance_qc_agent');

export const renderDashboardOverview = (
  dashboardSections: DashboardSectionItem.SectionConfig[],
  loan: BlendBridge.API.Loan,
  documents: BlendBridge.API.Document[],
  removeDoc: (id: string) => void,
  setInstructionOpen: (val: boolean) => void,
  areInstructionsOpen: boolean,
): React.ReactElement =>
  renderDefaultDashboardOverview(
    dashboardSections,
    loan,
    getDefaultDocumentSectionConfigs(documents, removeDoc),
    setInstructionOpen,
    areInstructionsOpen,
  );

export const renderProfileSidebar = renderDefaultProfileSidebar;

export const getAllowedRoutes = (_me: BlendBridge.API.User): { allowedRoutes: Route[]; defaultLandingPath: Route } => {
  return {
    allowedRoutes: ['/qc-search', '/:loanId/dashboard'],
    defaultLandingPath: '/qc-search',
  };
};
